<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>İP ünvan</h1>
      </div>

      <div class="col-md-6">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <input type="text" v-model="ip">
          <button @click="getIPLocation">axtar</button>
        </div>
        <div class="note" v-show="data.error">İP ünvan düzgün deyil!</div>
        <div class="spinner" v-if="loading"><div></div><div></div><div></div></div>
        <transition appear name="fade" mode="out-in" v-else>
          <table key="data" v-show="!data.error">
            <tbody>
              <tr>
                <th>İP ünvan:</th>
                <td>{{ data.ip }}</td>
              </tr>
              <tr>
                <th>Təşkilat:</th>
                <td>{{ data.org }}</td>
              </tr>
              <tr>
                <th>Məkan:</th>
                <td>
                  <p>{{ data.city }}, {{ data.country_name }}</p>
                  <p>{{ data.timezone }}, ({{ data.utc_offset }})</p>
                </td>
              </tr>
            </tbody>
          </table>
        </transition>
      </div>

      <div class="col-md-6">
        <gmap-map
          ref="map"
          :center="{lat: +this.data.latitude, lng: +this.data.longitude}"
          :zoom="6"
          style="width: 100%; height: 310px;">
        </gmap-map>
      </div>

      <div class="col-12">
        <h2>Fiber-optik internet provayderlər</h2>
        <table>
          <thead>
            <tr>
              <th>Provayder</th>
              <th>Telefon</th>
              <th>Sayt</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="provider in providers">
              <td>{{ provider.name }}</td>
              <td>{{ provider.phone }}</td>
              <td>{{ provider.web }}</td>
            </tr>
          </tbody>
        </table>
        <div class="note">
          <p>Beynəlxalq internet trafikinin ölkəyə çatdırılması "Delta Telecom" və "AzerTelecom" telekommunikasiya operatorları tərəfindən təmin olunur.</p>
          <p></p>
          <p></p>
        </div>
      </div>

    </div>
  </div>
</template>

<script> 

  import axios from 'axios';

  export default {
    data(){
      return {
        ip: null,
        loading: false,
        data: {},
        providers: [
          {'name': 'CityNet', 'phone': '*1177', 'web': 'www.citynet.az'},
          {'name': 'Connect', 'phone': '159', 'web': 'www.connect.az'},
          {'name': 'NarNet', 'phone': '1827', 'web': 'www.nar.az/narnet/'},
          {'name': 'CityLine', 'phone': '(012) 310 00 66', 'web': 'www.cityline.az'},
          {'name': 'Metronet', 'phone': '128', 'web': 'www.metronet.az'},
          {'name': 'Eurosel', 'phone': '921', 'web': 'www.eurosel.az'},
          {'name': 'AzFiberNet', 'phone': '(012) 565 44 44', 'web': 'www.azfiber.net'},
          {'name': 'Avirnet', 'phone': '176', 'web': 'www.avirnet.az'},
          {'name': 'Global Network', 'phone': '(012) 408 88 08', 'web': 'www.qlobalnet.az'},
          {'name': 'iZone', 'phone': '(012) 310 01 01', 'web': 'www.izone.az'},
          {'name': 'Bravo', 'phone': '(012) 310 34 01', 'web': 'www.bravoonline.az'},
          {'name': 'Teleport', 'phone': '*0050', 'web': 'www.teleport.az'},
          {'name': 'KATV1', 'phone': '127', 'web': 'www.katv1.az'},
          {'name': 'Ailə NET', 'phone': '920', 'web': 'www.aile.tv'}
        ]
      }
    },
    mounted(){
      this.getCurrentLocation();
    },
    methods: {
      getCurrentLocation: function(){
        this.loading = true;
        axios.get('https://ipapi.co/json/?key=7b03665472f0ee9bf681a88b452f8ba35d3cc6bb')
          .then(response => {
            this.loading = false;
            this.ip = response.data.ip;
            this.data = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      getIPLocation: function(){
        this.loading = true;
        let ip = this.ip;
        axios.get('https://ipapi.co/' + ip + '/json/?key=7b03665472f0ee9bf681a88b452f8ba35d3cc6bb')
          .then(response => {
            this.loading = false;
            this.ip = response.data.ip;
            this.data = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
</script>

<style scoped>
  table {
    margin-bottom: 1rem;
  }
  button {
    margin-left: 1rem;
    background: #003366;
    color: #FFF;
  }
</style>


// WEBPACK FOOTER //
// src/components/calc/Internet.vue